import React from "react";

import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { BetBuilderPicksOfferTips } from "../BetBuilderPicksOfferTips";
import { observer } from "mobx-react";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";
import { QuickPlayPopupsTeams } from "@features/quick-play/mobile/common/QuickPlayPopupsTeams";
import QuickPlayEventResultAndTime from "@features/quick-play/shared/QuickPlayEventResultAndTime";

export default observer(function BetBuilderPickEventPopupBody(props: {
	BBPick: BetBuilderPick;
}) {
	const store = useOfferContext<OfferStore.EventViewStore>();

	return (
		<div className="card--bbp">
			<div className="card__body card--qp__body card--bbp__body">
				<QuickPlayEventResultAndTime
					event={store.event}
					startTime={props.BBPick.startTime}
				/>

				<div className="card--qp__event card--bbp__event">
					<QuickPlayPopupsTeams
						sportData={props.BBPick.multiOffers[0].sportData}
						eventId={props.BBPick.eventId}
						isBetBuilder
						isLinkDisabled
					/>
				</div>

				<div className="card--qp__offer card--bbp__offer">
					<BetBuilderPicksOfferTips
						multiOffers={props.BBPick.multiOffers}
						isPopup
						isWrapped={true}
					/>
				</div>
			</div>
		</div>
	);
});
